module.exports = __webpack_public_path__ + "static/img/jh.5dff8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jh.png
// module id = 9MZM
// module chunks = 1